'use strict';

const axios = require('axios');
import { gtmCustomEvent } from '@jspartials/gtm-utils';
import { updateMiniCartTotalQuantity } from '@jscomponents/mini-cart';

// Classnames
const DONATIONS_WRAPPER_CLASSNAME = 'js-donation_include';

// Selectors
const DONATIONS_WRAPPER_SELECTOR = `.${DONATIONS_WRAPPER_CLASSNAME}`;

// Variables
const endpointUpdateCartItemQuantity =
  globalVariables.endpoint.updateCartItemQuantity;
const endpointAddToCart = globalVariables.endpoint.addToCart;
const eventAfterAddToCart = new CustomEvent('product:afterAddToCart');

const eventCartIsFull = new CustomEvent('cartIsFull');
var donationsWrapper;

// Functions
const addToCartItem = (itemPID, quantity = 1, list = '', options) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('pid', itemPID);
    formData.append('quantity', quantity);
    formData.append('options', options);

    axios
      .post(endpointAddToCart, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(function (response) {
        if (response.status === 200) {
          var data = response.data;

          // Update mini cart total quantity
          updateMiniCartTotalQuantity(data.quantityTotal);

          // Dispatch event to refresh cart and update mini cart
          document.dispatchEvent(
            new CustomEvent('refreshCart', {
              detail: {
                data: data
              }
            })
          );

          // Dispatch event to make actions after add to cart
          document.dispatchEvent(eventAfterAddToCart);

          // Dispatch event to update GTM dataLayer after add to cart
          document.dispatchEvent(
            new CustomEvent(gtmCustomEvent.afterAddToCart, {
              detail: {
                productId: itemPID,
                list: list
              }
            })
          );

          // Dispatch event to update cart after add to cart
          document.dispatchEvent(
            new CustomEvent('afterAddToCartShow', {
              detail: {
                data: data
              }
            })
          );

          // Check if cart is full
          if (data.basketModel.isCartFull) {
            document.dispatchEvent(eventCartIsFull);
          }

          resolve(data);
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status === 409) {
          document.dispatchEvent(eventCartIsFull);
        }
        reject(error);
      })
      .then(function () {
        donationsWrapper = document.querySelector(DONATIONS_WRAPPER_SELECTOR);

        if (donationsWrapper) {
          document.dispatchEvent(
            new CustomEvent('donations:afterAddToCart', {
              detail: {
                checkboxID: itemPID
              }
            })
          );
        }
      });
  });
};

const updateItemQuantity = (
  isCartFull = false,
  rawQuantity = 0,
  rawOldQuantity = 0,
  rawItemPID = '',
  rawItemUUID = '',
  list = ''
) => {
  const quantity = Math.trunc(rawQuantity);
  const oldQuantity = Math.trunc(rawOldQuantity);
  const itemPID = rawItemPID.trim();
  const itemUUID = rawItemUUID.trim();

  return new Promise((resolve, reject) => {
    if (isCartFull && oldQuantity <= quantity) {
      document.dispatchEvent(eventCartIsFull);
      reject('cartIsFull');
    } else {
      if (!quantity || !itemPID || !itemUUID) {
        reject('Missing required parameters');
      }

      const formData = new FormData();
      formData.append('quantity', quantity);
      formData.append('pid', itemPID);
      formData.append('uuid', itemUUID);
      axios
        .post(endpointUpdateCartItemQuantity, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;

            if (data.basketModel.isCartFull) {
              document.dispatchEvent(eventCartIsFull);
            }

            updateMiniCartTotalQuantity(data.basketModel.numItems);

            if (rawQuantity > rawOldQuantity) {
              document.dispatchEvent(eventAfterAddToCart);
              document.dispatchEvent(
                new CustomEvent(gtmCustomEvent.afterAddToCart, {
                  detail: {
                    productId: itemPID,
                    list: list
                  }
                })
              );
            }

            if (rawQuantity < rawOldQuantity) {
              document.dispatchEvent(
                new CustomEvent(gtmCustomEvent.afterRemoveFromCart, {
                  detail: {
                    productId: itemPID,
                    list: list
                  }
                })
              );
            }

            resolve(data);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    }
  });
};

function removeItemFromCart(itemPID, itemUUID, list = '') {
  // Elements
  var endpointRemoveProductLineItem =
    globalVariables.endpoint.removeProductLineItem;

  const formData = new FormData();
  formData.append('pid', itemPID);
  formData.append('uuid', itemUUID);

  return new Promise((resolve, reject) => {
    axios
      .post(endpointRemoveProductLineItem, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(function (response) {
        if (response.status === 200) {
          var data = response.data;

          updateMiniCartTotalQuantity(data.basketModel.numItems);

          resolve(data);

          document.dispatchEvent(
            new CustomEvent(gtmCustomEvent.afterRemoveFromCart, {
              detail: {
                productId: itemPID,
                list: list
              }
            })
          );
        }
      })
      .catch(function (error) {
        reject(error);
      })
      .then(function () {
        donationsWrapper = document.querySelector(DONATIONS_WRAPPER_SELECTOR);

        if (donationsWrapper) {
          document.dispatchEvent(
            new CustomEvent('donations:afterAddToCart', {
              detail: {
                checkboxID: itemPID
              }
            })
          );
        }
      });
  });
}

const productCanBeAddedInCart = (productId, quantity) => {
  const formData = new FormData();
  formData.append('pid', productId);
  formData.append('quantity', quantity);
  return new Promise((resolve, reject) => {
    axios
      .post(globalVariables.endpoint.productCanBeAddedInCart, formData)
      .then(function (response) {
        if (response.status === 200) {
          resolve(response.data);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export {
  addToCartItem,
  updateItemQuantity,
  removeItemFromCart,
  productCanBeAddedInCart,
  eventCartIsFull
};
